import React, { useState } from "react";
import classes from "./UpdatePW.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import InputText from "../../../../components/Inputs/InputText";
import PassWordValidations from "../../../../components/PassWordValidations";
import {
  checkAllValidations,
  checkPasswordValidations,
} from "../../../../helpers";
import * as d from "../../../../constants/defaults";
import * as Auth from "@aws-amplify/auth";
import Spinner from "../../../../components/Spinner";
import Alert from "../../../../components/Alerts";
import { useTranslation } from "react-i18next";

export default function UpdatePW() {
  // #01 Hooks
  const { t } = useTranslation();
  // #02 Reference
  // #03 States
  const [alert, setAlert] = useState(null as any);
  const [isLoading, setIsLoading] = useState(false);
  const [isPWVisible, setPWVisible] = useState(false);
  const [passOld, setPassOld] = useState("");
  const [passNew, setPassNew] = useState("");
  const [passConfirm, setPassConfirm] = useState("");

  const resetFromData = () => {
    setPassOld("");
    setPassNew("");
    setPassConfirm("");
  };

  const updatePwHandle = (pwOld: string, pwNew: string, pwConfirm: string) => {
    if (checkAllValidations(pwNew, pwConfirm)) {
      window.scrollTo(0, 0);
      setIsLoading(true);
      Auth.getCurrentUser()
        .then((user: any) => {
          return Auth.updatePassword({oldPassword: pwOld, newPassword: pwNew});
        })
        .then((res: any) => {
          resetFromData();
          setAlert({
            text: "infos.information_saved_successfully",
            alertType: "success",
          });
        })
        .catch((err: any) => {
          console.error("[error]", err.message);
          if (pwNew !== pwConfirm)
            setAlert({
              text: "infos.passwords_do_not_match",
              alertType: "danger",
            });
          else
            setAlert({
              text: "infos.error_saving",
              alertType: "danger",
            });
        })
        .then(() => setIsLoading(false));
    } else {
      setAlert({
        text: "infos.without_changes",
        alertType: "info",
      });
    }
  };

  const showInfos = passNew !== "" || passConfirm !== "";

  const btnDisabled =
    passOld.length < 8 ||
    passNew.length < 8 ||
    passConfirm.length < 8 ||
    !checkAllValidations(passNew, passConfirm);

  let _content = null;
  if (isLoading) _content = <Spinner center />;
  else
    _content = (
      <form
        action=""
        className={classes.InnerForm}
        onSubmit={(e) => {
          e.preventDefault();
          updatePwHandle(passOld, passNew, passConfirm);
        }}
      >
        {alert && (
          <Alert
            text={t(alert.text)}
            danger={alert.alertType === "danger"}
            warning={alert.alertType === "info"}
            success={alert.alertType === "success"}
          />
        )}
        <InputText
          required={true}
          label="Senha atual"
          alt="Inserir senha atual"
          type={d.PASSWORD}
          value={passOld}
          onChange={setPassOld}
          onClickShowPw={setPWVisible}
          showPw={isPWVisible}
          showPWIcon
        />
        <InputText
          required={true}
          label="Nova senha"
          alt="Cadastrar nova Senha"
          type={d.PASSWORD}
          value={passNew}
          onChange={setPassNew}
          showPw={isPWVisible}
        />

        <InputText
          required={true}
          label="Confirmar nova senha"
          alt="Confirmar nova senha"
          type={d.PASSWORD}
          value={passConfirm}
          onChange={setPassConfirm}
          onClickShowPw={setPWVisible}
          showPw={isPWVisible}
        />

        <RoundButton
          disabled={btnDisabled}
          full
          type={d.SUBMIT}
          text="Salvar"
          title="Salvar nova senha"
          // onClick={() => {}}
        />
        {showInfos && (
          <PassWordValidations
            className={classes.Mt}
            {...checkPasswordValidations(passNew, passConfirm)}
          />
        )}
      </form>
    );

  return (
    <>
      <div className={classes.PasswordUpdate}>
        <PageHeader
          title={"Senhas"}
          subtitle={"Atualizar senhas de acesso a este sistema"}
        />
        <PageMain center>
          <div className={classes.ChangePassword}>
            {_content}
          </div>
        </PageMain>
      </div>
    </>
  );
}
